import CryptoJS from 'crypto-js'

/**
 * 丽家会接口加密方法
 * add by lty
 * create time 20190307
 * 
 * @param {string} params 传给接口的参数
 * 
 * @key aes-128-ecb 加密的 key值 是 A1f@1l*g6EGjfnbf 
 * @Pkcs7 ecb 加密的时候，key 和 _paramStr 必须为16位字节，Pkcs7用于补全字节数
 * 
 * @return 返回接口所需的参数对象，json_data 和 xb_key 是后端约定好的字段
 */ 
export const cleanParams = (params) => {
  // 把对象转字符串
  let _params = JSON.stringify(params)

  // 把传给接口的参数 md5 加密
  let _xbKey = CryptoJS.MD5(_params).toString()

  // 把传给接口的参数 aes-128-ecb 加密
  const _key = CryptoJS.enc.Utf8.parse('A1f@1l*g6EGjfnbf')
  let _paramStr = CryptoJS.enc.Utf8.parse(_params)
  let _encrypted = CryptoJS.AES.encrypt(_paramStr, _key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  let _hexStr = _encrypted.ciphertext.toString()
  let _oldHexStr = CryptoJS.enc.Hex.parse(_hexStr)
  // 将密文转为Base64的字符串
  let _base64Str = CryptoJS.enc.Base64.stringify(_oldHexStr)
  
  return {
    'json_data': encodeURIComponent(_base64Str),
    'xb_key': _xbKey
  }
}


// WEBPACK FOOTER //
// ./src/utils/clean-encrypt.js